import React from 'react'
import { AddressEdit } from '../AddressEdit'
import { ProfileNameEdit } from '../ProfileNameEdit'
import { useCustomer } from '../../../hooks/useCustomer'
import { ShowLoadingOrError } from '../../../components/ShowLoadingOrError'
import { CustomerInlineInput } from '../CustomerInlineInput'
import { Avatar, HorizontalStack, Icon, TooltipPopOver } from '@ztechapps/webui.util'
import { Card } from 'react-bootstrap'
import { PhoneNumberInlineInput } from '@ztechapps/webui.input'
import { CustomerCompanyNameInlineInput } from '../CustomerCompanyNameInlineInput'

export const MainProfile = () => {
  const { document, loading, error } = useCustomer()
  return (
    <ShowLoadingOrError loading={loading} error={error}>
      <Card>
        <Card.Body>
          <HorizontalStack className="justify-content-between align-items-center">
            <div>
              <ProfileNameEdit initialValues={document} />
              <p> {document?.profile?.email} </p>
            </div>

            <div>
              <Avatar size={150} src={document?.profile?.picture} />
            </div>
          </HorizontalStack>
          <div>
            <CustomerInlineInput
              initialValues={document}
              parentInputComponent={PhoneNumberInlineInput}
              name="phone"
              emptyContent={<p className="text-info font-italic"> Click here to add phone number.</p>}
              displayContent={(e) => (
                <TooltipPopOver tooltipBody="Phone">
                  <p>
                    <Icon name="phone" /> {e}
                  </p>
                </TooltipPopOver>
              )}
            />
          </div>
          <CustomerCompanyNameInlineInput customer={document} />

          <div>
            <div className="fw-bold text-muted">
              <i className="fa fa-map-marker  " /> &nbsp; Default shipping address:
            </div>
            <AddressEdit initialValues={document} />
          </div>
        </Card.Body>
      </Card>
    </ShowLoadingOrError>
  )
}
